<div class="reg-container">
  <!-- 左パネル：動画  -->
  <div class="left-panel">
    <img class="left-panel__animation" src="assets/video/4_bye.webp" alt="" />

  </div>

  <!-- 右パネル：フォーム + 進捗 -->
  <div class="right-panel">
    <div class="form-card">
      <div class="form-header">
        <div class="form-header__icon">
          @if (iconUrl) {
            <img [src]="iconUrl" alt="アイコン" class="form-header__icon-img" />
          }
        </div>
        <h2 class="form-title">Biz-Marche</h2>
      </div>

      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="field-group">
          @for (item of fieldItems; track $index) {
            @if (isRow(item)) {
              <div class="name-row">
                @for (field of item.fields; track field.controlName) {
                  <div class="field-wrap">
                    <input
                      [formControlName]="field.controlName"
                      [type]="field.type"
                      [placeholder]="field.placeholder"
                      [attr.autocomplete]="getAutocomplete(field.controlName)"
                      class="field-input"
                      [class.field-input--error]="hasDisplayError(field.controlName)"
                      (focus)="onFocus(field.controlName)"
                      (blur)="onBlur()"
                    />

                    @if (isChecking(field.controlName) && getPendingMessage(field.controlName)) {
                      <span class="field-hint field-hint--checking">
                        {{ getPendingMessage(field.controlName) }}
                      </span>
                    } @else {
                      @if (getErrorMessage(field.controlName); as msg) {
                        <span class="field-hint field-hint--error">{{ msg }}</span>
                      }
                    }
                  </div>
                }
              </div>
            } @else {
              <div class="field-wrap">
                <input
                  [formControlName]="asField(item).controlName"
                  [type]="asField(item).type"
                  [placeholder]="asField(item).placeholder"
                  [attr.autocomplete]="getAutocomplete(asField(item).controlName)"
                  class="field-input"
                  [class.field-input--error]="hasDisplayError(asField(item).controlName)"
                  (focus)="onFocus(asField(item).controlName)"
                  (blur)="onBlur()"
                />

                @if (isChecking(asField(item).controlName) && getPendingMessage(asField(item).controlName)) {
                  <span class="field-hint field-hint--checking">
                    {{ getPendingMessage(asField(item).controlName) }}
                  </span>
                } @else {
                  @if (getErrorMessage(asField(item).controlName); as msg) {
                    <span class="field-hint field-hint--error">{{ msg }}</span>
                  }
                }
              </div>
            }
          }
        </div>

        <button type="submit" class="submit-btn" [disabled]="form.invalid">
          <!-- API チェック中はボタンテキストも変化 -->
          {{ form.pending ? '確認中...' : buttonLabel }}
        </button>
      </form>
    </div>

    <!-- 進捗インジケーター（別コンポーネント） -->
    <biz-progress-steps [steps]="steps" [form]="form" [activeField]="activeField" />
  </div>
</div>
